

























































import { defineComponent, ref, watch } from '@vue/composition-api';
import { debounce } from '@/bundles/App/helpers';
import { ServiceFactory } from '@/service/ServiceFactory';
import { useStore } from '@/utils/use-store';
const HomeworkService = ServiceFactory.get('homework');

export default defineComponent({
  name: 'WeeklyChallangeBaseForm',
  emits: ['submit', 'close'],

  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    defaultImage: {
      type: String,
      default: '',
    },
    entryData: {
      type: Object,
      default: () => ({}),
    },
    saveLoadingEntry: Boolean,
  },


  setup(props, {emit}) {
    const form = ref<any>(null);
    const valid = ref(true);
    const name = ref('');
    const imageFile = ref<any>(null);
    const challengeImage = ref('');
    const fileReader = ref<FileReader | null>(null);
    const homeworkKeyword = ref('');
    const selected = ref(null);
    const homework = ref([]);
    const homeworkLoading = ref(false);
    const store = useStore();
    const { accessToken: token } = store.state.user;

    watch(() => props.entryData, (newVal) => {
      if (newVal) {
        name.value = newVal.name || '';
        challengeImage.value = newVal.image || '';
        selected.value = newVal.homework_id || null;
      }
    }, { immediate: true, deep: true });

    function handleImageChange(file: File) {
      if (!file) {
        challengeImage.value = '';
        imageFile.value = null;
        return;
      }

      fileReader.value = new FileReader();
      fileReader.value.onload = (e) => {
        if (e.target?.result) {
          challengeImage.value = e.target.result as string;
          imageFile.value = file;
        }
      };
      fileReader.value.readAsDataURL(file);
    }

    function keywordSearch() {
      if (!homeworkKeyword.value?.length) {
        return fetchHomework({});
      }
      fetchHomework({keyword: homeworkKeyword.value});
    }

    const searchWrapper = debounce(keywordSearch, 500);
    watch(homeworkKeyword, () => {
      searchWrapper();
    });

    async function submitEventHandler() {
      if (!selected.value || !name.value) {
        return;
      }
      const payload: any = {
        name: name.value,
        homework_id: selected.value,
      };
      if (imageFile.value) {
        payload.file = imageFile.value;
      }
      emit('submit', payload);
      clearForm();
    }

    function clearForm() {
      name.value = '';
      imageFile.value = null;
      selected.value = null;
      homeworkKeyword.value = '';
      challengeImage.value = '';
    }

    function closeForm() {
      emit('close');
      clearForm();
    }

    async function fetchHomework() {
      homeworkLoading.value = true;
      try {
        const { data } = await HomeworkService.list(token);
        homework.value = data.filter((item: any) => item.exercise.length);
      } finally {
        homeworkLoading.value = false;
      }
    }

    return {
      form,
      valid,
      name,
      imageFile,
      challengeImage,
      homeworkKeyword,
      selected,
      homework,
      homeworkLoading,
      submitEventHandler,
      handleImageChange,
      closeForm,
    };
  },
});
